
  var _styles = {
  "city-deop-down-content": {
    "position": "relative",
    "display": "flex",
    "flexDirection": "row",
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem",
    "height": "0.8rem"
  },
  "city-deop-down-card": {
    "paddingTop": "0.13333rem",
    "paddingRight": "0.24rem",
    "paddingBottom": "0.13333rem",
    "paddingLeft": "0.24rem",
    "flexShrink": 0,
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "height": "0.8rem",
    "borderRadius": "0.10667rem",
    "position": "relative"
  },
  "city-deop-down-text": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.32rem",
    "color": "rgb(34,34,34)",
    "letterSpacing": 0,
    "fontWeight": "500"
  },
  "modal-content": {
    "backgroundColor": null,
    "left": 0,
    "width": "10rem",
    "height": "100%"
  },
  "city-deop-down-modal": {
    "paddingTop": "0.32rem",
    "paddingRight": "0.16rem",
    "paddingBottom": "0.16rem",
    "paddingLeft": "0.32rem",
    "position": "absolute",
    "left": "0.32rem",
    "top": "1rem",
    "borderRadius": "0.24rem",
    "width": "9.36rem",
    "backgroundColor": "rgb(255,255,255)",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "flex-start",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "overflow": "hidden",
    "zIndex": 999
  },
  "city-deop-down-modal-card": {
    "height": "0.8rem",
    "width": "2.05333rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "marginBottom": "0.16rem",
    "marginRight": "0.16rem",
    "background": "#f4f4f4",
    "borderRadius": "0.16rem"
  },
  "city-deop-down-modal-card-checked": {
    "height": "0.8rem",
    "width": "2.05333rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "marginBottom": "0.16rem",
    "marginRight": "0.16rem",
    "backgroundColor": "rgb(255,241,236)",
    "borderRadius": "0.16rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,75,16)"
  },
  "city-deop-down-modal-card-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(102,102,102)",
    "letterSpacing": 0,
    "fontWeight": "400"
  },
  "city-deop-down-modal-card-text-checked": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0,
    "fontWeight": "400"
  },
  "base": {
    "position": "absolute",
    "top": "0.86667rem",
    "left": "0.33333rem",
    "width": "0.53333rem",
    "height": "0.13333rem",
    "zIndex": 50
  }
};



  module.exports = _styles;
  